import { create } from "zustand";
import { devtools } from "zustand/middleware";

export type MobileSubRoute = {
    name: string;
    label: string;
    route: string;
    icon: string;
    showOnBar: boolean;
}

export type MobileRoute = {
    name: string;
    label: string;
    route: string;
    icon: string;
    showOnBar: boolean;
    subRoutes?: MobileSubRoute[]
}
export type MobileFunction = {
    name: string;
    requiredRoles?: string[];
    routes?: { route: string, label: string, name: string, icon?: string, showOnBar?: boolean, requiredRoles?: string[] }[];
    showOnBar?: boolean
}

interface NavigationState {
    previousRoute: string;
    currentRoute: string;
    currentSubRoutes: MobileSubRoute[];
    useSubMenu: boolean,
    routes: MobileRoute[];
    currentCategoryLabel: string;
    setUseSubMenu: (useSubMenu: boolean) => void,
    setCurrentCategoryLabel: (currentCategoryLabel: string) => void;
    setPreviousRoute: (route: string) => void;
    setCurrentRoute: (route: string) => void;
    setRoutes: (routes: MobileRoute[]) => void;
    setCurrentSubRoutes: (subRoutes: MobileSubRoute[]) => void;
}

export const useNavigationStore = create<NavigationState>()(
    devtools(
        (set) => ({
            previousRoute: "",
            currentRoute: "Home",
            routes: [],
            currentCategoryLabel: "",
            useSubMenu: false,
            currentSubRoutes: [],
            setCurrentCategoryLabel: (currentCategoryLabel) => set({ currentCategoryLabel }),
            setPreviousRoute: (route) => set({ previousRoute: route }),
            setCurrentRoute: (route) => set({ currentRoute: route }),
            setRoutes: (routes) => set({ routes }),
            setCurrentSubRoutes: (currentSubRoutes) => set({ currentSubRoutes }),
            setUseSubMenu: (useSubMenu: boolean) => set({ useSubMenu })
        })
    )
);